import React, { Component } from 'react'

class Product extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            productLoaded: false,
        };
        this.product = null;
        this.image = null;
        this.imageAlt = null;
        this.categoriesList = [];
        this.abortController = new window.AbortController();
    } 
    componentDidMount(){
        this.getProduct();
    }
    componentWillUnmount(){
        this.abortController.abort();
    }
    getProduct(){
        const { id, type } = this.props.data;
        if(id && type){
            fetch( window.wpApiSettings.root + `wpnlf/v1/products/${id}`, { signal: this.abortController.signal } )
            .then( response => response.json() )
            .then( product => {
                this.product = product;
                // Featured Media
                if( 0 !== product.featured_media && undefined !== product.featured_media ){
                    this.image = product.featured_media_thumbnail;
                    this.imageAlt = product.featured_media_alt;
                }
                // Categories
                if( product.categories.length > 0 ){
                    this.categoriesList = product.categories;
                }
                this.setState( { productLoaded: true } );
            })
            .catch( error => {
                if (error.name === 'AbortError') return; // expected, this is the abort, so just return
                throw error; // must be some other error, handle however you normally would
            })
        }
    }
        
    render() {
        const {productLoaded} = this.state;
        if( productLoaded ){
            return (
                <div className="nlf-viewer-block nlf-viewer-product">
                    <div className="nlf-product-header">
                    <div className="nlf-product-header-meta">
                        <span className="nlf-product-subtitle">{window.nlfL10n.Discover}</span>
                        <h2 className="nlf-product-title">{this.product.title}</h2>
                        {this.categoriesList.length > 0 && <div className="nlf-product-categories" dangerouslySetInnerHTML={ { __html: "> " + this.categoriesList.join(', ') } }></div>}
                    </div>
                    <div className="nlf-product-image">
                    {this.image && this.props.data['showImage'] && <a href={this.product.link} title={this.product.title} className="image"><img src={this.image} alt={this.imageAlt} /></a>}
                    </div>
                    </div>
                    <div className="nlf-product-description" dangerouslySetInnerHTML={ { __html: this.product.short_description } }></div>
                    <div className="nlf-product-footer">
                    <a href={this.product.link} title={this.product.title} className="nlf-button-readmore nlf-button btn btn-default"><span>{window.nlfL10n.ReadOn}</span></a>
                    {this.props.data['showBtnQuote'] && <a href={this.props.data['btnQuoteURL'].replace('[slug]', this.product.slug)} title={this.props.data['btnQuoteLabel']} className="nlf-button-quote nlf-button btn btn-default"><span>{this.props.data['btnQuoteLabel']}</span></a>}
                    </div>
                </div>
            );
        }
        return '';
    }
}

export default Product


// WEBPACK FOOTER //
// ./src/Product.js